import { createActions, createReducer } from 'reduxsauce';
import update from 'immutability-helper';
import type { ApiValidationError } from 'contracts/Common';

const { Types, Creators } = createActions(
  {
    request: ['id', 'putData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage', 'validationErrors'],
    reset: [],
  },
  { prefix: 'UPDATE_BUILDING_' }
);

export interface UpdateBuildingRequestAction {
  id: number;
  putData: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface State {
  loading: boolean;
  errorMessage: string | null;
  validationErrors: ApiValidationError[];
}

const INITIAL_STATE: State = {
  loading: false,
  errorMessage: null,
  validationErrors: [],
};

export const updateBuilding = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: (state: State) =>
    update(state, {
      loading: { $set: true },
      errorMessage: { $set: null },
      validationErrors: { $set: [] },
    }),
  [Types.SUCCESS]: (state: State) =>
    update(state, { loading: { $set: false } }),
  [Types.FAILURE]: (
    state: State,
    action: { errorMessage: string; validationErrors?: ApiValidationError[] }
  ) =>
    update(state, {
      loading: { $set: false },
      errorMessage: { $set: action.errorMessage },
      validationErrors: { $set: action.validationErrors || [] },
    }),
  [Types.RESET]: () => INITIAL_STATE,
});

export const UpdateBuildingTypes = Types;
export const UpdateBuildingActions = Creators;
